import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  acceptRejectDocument,
  getDocumentFile,
  postDocumentFile,
  updateDocumentFile,
} from "../../../store/actions";
import download from "downloadjs";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import Loading from "../../../Common/extra/loading";
import { saveAs } from "file-saver";

const ViewAddressIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId, docId } = useParams();
  const [data, setData] = useState({
    image_url: "",
    fileName: "Drag/Drop or Upload File",
    status: "submitted",
  });
  const [loading, setLoading] = useState(false);
  const DocumentData = useSelector((s) => s?.Customers?.getDocumentFile?.data);
  const docs =
    DocumentData &&
    DocumentData?.image_url &&
    DocumentData?.image_url.length > 0 &&
    DocumentData?.image_url.map((url) => ({ uri: url }));
  const [activeDocument, setActiveDocument] = useState([]);

  useEffect(() => {
    if (DocumentData && DocumentData?.image_url) {
      setData((pre) => ({ ...pre, image_url: DocumentData?.image_url }));
    }
  }, [DocumentData]);

  useEffect(() => {
    if (docs) {
      setActiveDocument(docs[0]);
    }
  }, [DocumentData]);

  useEffect(() => {
    if (data.image_url) {
      setData((pre) => ({
        ...pre,
        fileName:
          data.image_url && data.image_url.map((item) => item.split("/")[3]),
      }));
    }
  }, [data.image_url]);

  useEffect(() => {
    if (docId) {
      dispatch(getDocumentFile({ docId: docId, user_id: userId }));
    }
  }, [docId]);

  const handleStatusSubmit = (e, status) => {
    e.preventDefault();
    setLoading(true);
    const callBack = (res) => {
      if (res.status == 200) {
        toast.success("Success!");
        setLoading(false);
        dispatch(getDocumentFile({ docId: docId, user_id: userId }));
      }
    };
    dispatch(
      acceptRejectDocument(
        {
          user_id: userId,
          document_id: docId,
          status: status,
        },
        callBack
      )
    );
  };
  const handleDocumentChange = (Document) => {
    setActiveDocument(Document);
  };

  const handleDownloadClick = async () => {
    try {
      const response = await fetch(activeDocument?.uri);
      const blob = await response.blob();
      saveAs(blob, data.fileName);
    } catch (error) {
      console.log("Error downloading the file:", error);
    }
  };

  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href={`/customers/profile/${userId}`}>
                    Document
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Row className="justify-content-center doc-reverse">
                  <>
                    <Col md={12} className="text-center">
                      {(docs && docs.length > 0 && (
                        <>
                          <DocViewer
                            documents={docs}
                            activeDocument={activeDocument}
                            pluginRenderers={DocViewerRenderers}
                            onDocumentChange={handleDocumentChange}
                          />
                        </>
                      )) || <h5 className="mt-5">No Document Submitted</h5>}
                    </Col>
                    {DocumentData && (
                      <Col
                        md={6}
                        className="text-center doc-preview-btn d-flex gap-10 justify-content-center"
                      >
                        <a
                          className="text-white"
                          href={activeDocument?.uri}
                          target="blank"
                        >
                          <Button>Preview</Button>
                        </a>
                        <Button onClick={handleDownloadClick}>Download</Button>
                      </Col>
                    )}
                  </>

                  <Col lg="12" className="my-2">
                    <div className="pt-4 btn-wrp d-flex align-items-center">
                      {DocumentData && (
                        <div className="mt-4 d-flex gap-10 align-item-center justify-content-center">
                          <Button
                            className={
                              DocumentData?.status == "accepted" &&
                              "doc-disabled"
                            }
                            onClick={(e) => handleStatusSubmit(e, "accepted")}
                            disabled={DocumentData?.status == "accepted"}
                          >
                            Accept Doc
                          </Button>
                          <Button
                            className={
                              DocumentData?.status == "rejected"
                                ? "doc-disabled text-white"
                                : "text-white"
                            }
                            onClick={(e) => handleStatusSubmit(e, "rejected")}
                            disabled={DocumentData?.status == "rejected"}
                          >
                            Reject Doc
                          </Button>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default ViewAddressIndex;
